/* ══════════════════════════════════════════════════════════════════════════
   LG PRODUCT DOCS — documentos de la ficha que cambian con la variante
   Marcado: snippets/lg-product-docs.liquid (+ lg-product-doc-card.liquid)
   Estilos: lg-accordion-styles.css (.lg-doc*)

   Los documentos de FARO (instrucciones, plano, BIM, CAD, fotometría, EPREL)
   se sirven desde su CDN; su URL vive en el metacampo luzgurudocs.faro de cada
   variante; los de Fabrilamp (ficha técnica, certificado CE, etiqueta
   energética) desde su web, en luzgurudocs.fabrilamp. Al cambiar de variante: enlace de la variante → si no trae ese
   documento, el del producto → si tampoco, la tarjeta se oculta.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function leerMapa(caja) {
    var el = caja.querySelector('[data-lg-docs-variantes]');
    try {
      return (el && JSON.parse(el.textContent)) || {};
    } catch (e) {
      return {};
    }
  }

  function aplicar(caja, docs) {
    var visibles = 0;
    caja.querySelectorAll('[data-lg-doc]').forEach(function (a) {
      var url = (docs && docs[a.dataset.lgDoc]) || a.dataset.lgDocProducto || '';
      if (url) {
        a.setAttribute('href', url);
        a.hidden = false;
        visibles++;
      } else {
        a.hidden = true;
      }
    });
    var pro = caja.querySelector('[data-lg-docs-pro]');
    if (pro) pro.hidden = !pro.querySelector('[data-lg-doc]:not([hidden])');
    caja.hidden = visibles === 0;
  }

  function iniciar(caja) {
    if (caja.dataset.lgDocsListo) return;
    caja.dataset.lgDocsListo = '1';
    var mapa = leerMapa(caja);
    if (!Object.keys(mapa).length) return;

    function enlazar(intento) {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var v = event && event.data && event.data.variant;
          if (v) aplicar(caja, mapa[String(v.id)] || null);
        });
      } else if (intento < 50) {
        setTimeout(function () { enlazar(intento + 1); }, 100);
      }
    }
    enlazar(0);
  }

  function arrancar() {
    document.querySelectorAll('[data-lg-docs]').forEach(iniciar);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
